<div class="msb-wrapper w-100">
  <!-- Bar track -->
  <div
    class="msb-track"
    [style.height.px]="barHeight"
    [style.border-radius.px]="borderRadius">

    <div
      *ngFor="let segment of visibleSegments; let first = first; let last = last"
      class="msb-segment"
      [ngStyle]="getSegmentStyle(segment)"
      [style.border-radius]="first && last ? borderRadius + 'px'
                            : first       ? borderRadius + 'px 0 0 ' + borderRadius + 'px'
                            : last        ? '0 ' + borderRadius + 'px ' + borderRadius + 'px 0'
                            : '0'"
      [title]="segment.label + ' (' + segment.percentage + '%)'">
    </div>

    <!-- Remaining / empty track -->
    <div
      *ngIf="remainingPercentage > 0"
      class="msb-segment msb-remaining"
      [style.flex]="remainingPercentage"
      [style.border-radius]="visibleSegments.length === 0
        ? borderRadius + 'px'
        : '0 ' + borderRadius + 'px ' + borderRadius + 'px 0'">
    </div>

  </div>

  <!-- Legend row -->
  <div class="msb-legend">
    <div class="msb-legend-item flex-grow-1"*ngFor="let segment of visibleSegments">
      <span class="msb-dot" [style.background]="segment.color"></span>
      <span class="msb-legend-label">
        {{ segment.label }}
        <strong>({{ segment.percentage }}%)</strong>
      </span>
    </div>
  </div>

</div>
